module.exports = __webpack_public_path__ + "img/3 lora.a0baa39e.jpg";